import { render, staticRenderFns } from "./NewDeparture.vue?vue&type=template&id=8acae5d4&lang=html&"
import script from "./NewDeparture.vue?vue&type=script&lang=js&"
export * from "./NewDeparture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports